import React, { useState, useEffect } from 'react';
import { FiShoppingBag, FiMenu, FiX, FiDroplet } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function Navbar({ cartCount }) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="flex items-center gap-2 cursor-pointer">
            <SafeIcon icon={FiDroplet} className="text-2xl text-teal-800" />
            <span className="font-bold text-xl tracking-tight text-stone-900">TerraSip</span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex space-x-8 items-center">
            <a href="#shop" className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors">Shop</a>
            <a href="#loop" className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors">The Loop</a>
            <a href="#impact" className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors">Impact</a>
            <a href="#faq" className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors">FAQ</a>
          </div>

          {/* Cart & Mobile Toggle */}
          <div className="flex items-center gap-4">
            <button className="relative p-2 text-stone-900 hover:bg-stone-100 rounded-full transition-colors">
              <SafeIcon icon={FiShoppingBag} className="text-xl" />
              {cartCount > 0 && (
                <span className="absolute top-0 right-0 h-4 w-4 bg-teal-700 text-white text-[10px] font-bold flex items-center justify-center rounded-full">
                  {cartCount}
                </span>
              )}
            </button>
            <button 
              className="md:hidden p-2 text-stone-900"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="text-xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 w-full bg-white border-t border-stone-100 shadow-lg py-4 px-6 flex flex-col gap-4">
          <a href="#shop" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-stone-800">Shop</a>
          <a href="#loop" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-stone-800">The Loop</a>
          <a href="#impact" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-stone-800">Impact</a>
          <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-stone-800">FAQ</a>
        </div>
      )}
    </nav>
  );
}